export abstract class IdExtractor {
  url: string;

  constructor(url: string) {
    this.url = url;
  }

  // oxlint-disable-next-line no-unused-vars
  static is(url: string): boolean {
    return false;
  }

  abstract get id(): string;
}

export interface ThumbnailGetter {
  idExtractor: IdExtractor;
  fetchImgSrc: () => Promise<string>;
}

export class PassThroughThumbnailGetter implements ThumbnailGetter {
  idExtractor: IdExtractor = {
    url: "",
    get id() {
      return "";
    },
  };

  fetchImgSrc() {
    return Promise.resolve("");
  }
}

export function isHost(s: string, host: string): boolean {
  try {
    const url = new URL(s);
    return url.host === host;
  } catch {
    return false;
  }
}
